<template>
  <div class="automatedTasks">
    <!-- <h1>Automated Tasks table</h1> -->
    <v-data-table
      :headers="headers"
      :items="tasksList"
      :loading="loading"
      :items-per-page="-1"
      loading-text="Loading tasks list..."
      :style="{ 'max-width': '1280px' }"
      dense
    >
      <template
        v-for="header in headers.filter((h) => h.format)"
        v-slot:[`item.${header.value}`]="{ _, value }"
      >
        <span :key="header.text"> {{ header.format(value) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Utils from '@/utils';

export default {
  name: 'AuromatedTasks',
  props: { processType: { type: String, default: 'Payroll' }, counter: Number },

  data() {
    return {
      loading: false,
      tasksList: [],

      headers: [
        { text: 'Status', value: 'Status' },
        { text: 'Date Initiated', value: 'DateInitiated', format: this.formatDate },
        { text: 'Date Started', value: 'DateStarted', format: this.formatDate },
        { text: 'Date Finished', value: 'DateFinished', format: this.formatDate },
        { text: 'User Name', value: 'UserName' },
        { text: 'Description', value: 'Description' },
        { text: 'Reference', value: 'Reference' },
      ],
    };
  },

  watch: {
    counter() {
      this.getAutomationProcessListByType();
    },
  },

  mounted() {
    if (this.processType) this.getAutomationProcessListByType();
  },

  methods: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      if (date.getFullYear() < 1900) return null;
      return Utils.getDateStr(new Date(dateStr));
    },

    async getAutomationProcessListByType() {
      this.loading = true;

      try {
        const response = await this.$api.get(
          `/Automation/GetAutomationProcessListByType?processType=${this.processType}`
        );
        this.tasksList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
